import React from 'react';

interface PdfIconProps {}

export const PdfIcon: React.FC<PdfIconProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="40"
      viewBox="0 0 32 40"
    >
      <defs>
        <filter
          id="jdhpoymu8a"
          width="102.8%"
          height="104.8%"
          x="-1.4%"
          y="-1.7%"
        >
          <feOffset
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="2"
          ></feGaussianBlur>
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.164729893 0 0 0 0 0.184442935 0 0 0 0 0.16552638 0 0 0 0.138904065 0"
          ></feColorMatrix>
        </filter>
        <rect
          id="p4jir0ygyb"
          width="504"
          height="292"
          x="0"
          y="0"
          rx="10"
        ></rect>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          d="M0 0H1920V3621H0z"
          transform="translate(-339 -2786)"
        ></path>
        <g>
          <path
            fill="#F3F4F3"
            d="M0 0L1920 0 1920 1729 0 1729z"
            transform="translate(-339 -2786) translate(0 1892)"
          ></path>
          <g transform="translate(-339 -2786) translate(0 1892) translate(72 714)">
            <use fill="#000" filter="url(#jdhpoymu8a)" href="#p4jir0ygyb"></use>
            <use fill="#FFF" href="#p4jir0ygyb"></use>
            <g fill="#E64A4A" fillRule="nonzero">
              <path
                d="M267.176 31c.796 0 1.56.316 2.122.88l4.824 4.827c.562.563.878 1.326.878 2.12V66c0 2.761-2.239 5-5 5h-22c-2.761 0-5-2.239-5-5V36c0-2.761 2.239-5 5-5h19.176zm-13.812 30.36h-2.008c-.186 0-.33.05-.432.152-.08.081-.13.19-.146.325l-.006.107v4.48c0 .192.056.344.168.456.112.112.264.168.456.168s.344-.056.456-.168c.09-.09.144-.205.162-.346l.006-.11V64.88h1.344c.614 0 1.091-.155 1.432-.464.342-.31.512-.741.512-1.296s-.17-.987-.512-1.296c-.341-.31-.818-.464-1.432-.464zm13.192 0h-2.752c-.186 0-.33.05-.432.152-.08.081-.13.19-.146.325l-.006.107v4.48c0 .187.058.337.172.452.115.115.266.172.452.172.187 0 .335-.056.444-.168.088-.09.14-.205.158-.346l.006-.11v-1.8h1.944c.203 0 .352-.04.448-.12.096-.08.144-.203.144-.368 0-.17-.048-.296-.144-.376-.076-.064-.187-.102-.332-.115l-.116-.005h-1.944v-1.296h2.104c.203 0 .352-.04.448-.12.096-.08.144-.203.144-.368 0-.17-.048-.296-.144-.376-.096-.08-.245-.12-.448-.12zm-7.748 0H257.2c-.186 0-.33.05-.432.152-.08.081-.13.19-.146.325l-.006.107v4.472c0 .187.051.33.152.432.081.081.19.13.325.146l.107.006h1.608c.619 0 1.15-.112 1.592-.336.443-.224.78-.548 1.012-.972.232-.424.348-.93.348-1.516 0-.587-.117-1.09-.352-1.512-.234-.421-.573-.744-1.016-.968-.442-.224-.97-.336-1.584-.336zm-.088 1.008c1.2 0 1.8.603 1.8 1.808 0 1.15-.541 1.754-1.624 1.811l-.176.005h-.856v-3.624h.856zm-5.516-.056c.624 0 .936.272.936.816 0 .497-.265.765-.797.803l-.139.005h-1.184v-1.624h1.184zM265 33h-17c-1.657 0-3 1.343-3 3v22h28V41h-4c-2.21 0-4-1.79-4-4v-4zm-7.062 3.997c.327 0 .615.417.82.675.19.242.626.755-.243 4.377.876 1.792 2.117 3.617 3.306 4.867.852-.153 1.585-.23 2.182-.23 1.018 0 1.635.234 1.886.718.208.4.123.868-.253 1.39-.362.501-.861.767-1.443.767-.79 0-1.71-.495-2.736-1.47-1.844.38-3.997 1.062-5.737 1.815-.544 1.142-1.064 2.061-1.549 2.736-.622.862-1.163 1.295-1.695 1.349l-.114.006c-.226 0-.443-.073-.628-.21-.677-.503-.768-1.062-.725-1.443.118-1.048 1.426-2.144 3.89-3.262.977-2.12 1.907-4.734 2.46-6.918-.648-1.398-1.278-3.211-.819-4.275.162-.372.362-.658.737-.782.149-.049.523-.11.66-.11zm-3.846 13.7c-1.389.774-1.955 1.409-1.996 1.767-.006.059-.024.215.28.445.097-.03.662-.286 1.716-2.211zm4.007-7.094c-.464 1.592-1.078 3.311-1.737 4.868 1.358-.522 2.834-.977 4.221-1.3-.877-1.009-1.754-2.27-2.484-3.568zm6.032 4.166c-.328 0-.74.015-1.177.07.53.404.659.608 1.005.608.152 0 .586-.007.787-.284.096-.135.134-.22.149-.267-.08-.042-.186-.127-.764-.127zm-6.426-9.611c-.064.02-.864 1.13.062 2.07.617-1.362-.034-2.08-.062-2.07zM267.176 33H267v4c0 1.105.895 2 2 2h4v-.172c0-.265-.105-.52-.293-.707l-4.824-4.828c-.187-.188-.442-.293-.707-.293z"
                transform="translate(24 149)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
